/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const customTokenRefreshSchema = z.object({
	refresh: z.string(),
	access: z.string(),
});
